import { useQuery } from '@edreamsodigeo/frontend-api-client';
import { GET_USER_QUERY } from 'clientState/providers/operations/getUser';

export const useGetUserQuery = () => {
  return useQuery(GET_USER_QUERY, {});
};

export default useGetUserQuery;
